import { createContext, useContext } from 'react';

export const DriversContext = createContext({
  data: {},
  driverId: null,
  onCloseModal: () => {},
  loadingDetail: false,
  fetchListDriver: () => {},
  onUpdateStatusSuccess: () => {},
  onUpdateOrCreateDriverSuccess: () => {},
  fetchDetailDriver: () => {},
  // paymentVelocity is the shared useFetchPaymentVelocity instance: the header
  // badge and the fraud tab read the same state, so one fetch serves both and an
  // action taken in the tab updates the badge.
  paymentVelocity: null,
  canViewPaymentVelocity: false
});

DriversContext.displayName = 'DriversContext';

export const useDriversContext = () => useContext(DriversContext);
